export default {
      id: "nav-swiper-gooey-usage",
      viewBox: undefined,
      url: "../dist/images/" + "sprite.svg#nav-swiper-gooey-usage",
      toString: function () {
        return this.url;
      }
    }